import { createSlice, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit'
import {
  PurchaseOrderInboundDetailsInterface,
  PurchaseOrderInboundItemsInterface,
  PurchaseOrderInboundItemsQueryParamsInterface,
} from 'features/PurchaseOrder/@types/CheckQuantity'
import { InboundTaskCheckQtyItemSummaryType } from 'features/PurchaseOrder/services/inboundTask'
import {
  SLICE_NAME,
  fetchPoDetail,
  fetchInboundCheckQtyItems,
  fetchInboundCheckQtyItemsSummary,
} from './thunk'

export interface InboundTaskCheckQtyStateType {
  isLoading: boolean
  paramsInboundItems: PurchaseOrderInboundItemsQueryParamsInterface
  inboundCheckQtyDetail: Nullable<PurchaseOrderInboundDetailsInterface>
  inboundCheckQtyItems: PurchaseOrderInboundItemsInterface[]
  modalConfirmation: {
    isOpen: boolean
    inboundItemsSummary: InboundTaskCheckQtyItemSummaryType[]
  }
}

const initialState: InboundTaskCheckQtyStateType = {
  isLoading: false,
  paramsInboundItems: {
    page_index: 1,
    page_size: 20,
  },
  inboundCheckQtyDetail: null,
  inboundCheckQtyItems: [],
  modalConfirmation: {
    isOpen: false,
    inboundItemsSummary: [],
  },
}

const inboundTaskCheckQtySlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setModalConfirmationOpen: (state, action: PayloadAction<boolean>) => {
      state.modalConfirmation.isOpen = action.payload
    },
    resetModalConfirmation: (state) => {
      state.modalConfirmation = initialState.modalConfirmation
    },
    setInboundItemsQueryParams: (
      state,
      action: PayloadAction<Partial<PurchaseOrderInboundItemsQueryParamsInterface>>,
    ) => {
      state.paramsInboundItems = {
        ...state.paramsInboundItems,
        ...action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPoDetail.fulfilled, (state, action) => {
        state.inboundCheckQtyDetail = action.payload
      })
      .addCase(fetchInboundCheckQtyItems.fulfilled, (state, action) => {
        state.isLoading = false
        state.inboundCheckQtyItems = action.payload
      })
      .addCase(fetchInboundCheckQtyItemsSummary.fulfilled, (state, action) => {
        state.isLoading = false
        state.modalConfirmation.inboundItemsSummary = action.payload
      })
      .addMatcher(
        isPending(fetchPoDetail, fetchInboundCheckQtyItems, fetchInboundCheckQtyItemsSummary),
        (state) => {
          state.isLoading = true
        },
      )
      .addMatcher(
        isRejected(fetchInboundCheckQtyItems, fetchInboundCheckQtyItemsSummary),
        (state) => {
          state.isLoading = false
        },
      )
  },
})

export const { setModalConfirmationOpen, resetModalConfirmation, setInboundItemsQueryParams } =
  inboundTaskCheckQtySlice.actions

export default inboundTaskCheckQtySlice.reducer
